require('./blocks/news/news');
require('./blocks/tags.less');
require('./blocks/soc-area.less');
require('./blocks/rating-stars/rating-stars');
require('./blocks/review.less');
require('./blocks/reviews/reviews');
require('./blocks/impromptu/impromptu-comment');

require('./blocks/product/product.less');
require('./blocks/products-slider/products-slider');



// WEBPACK FOOTER //
// ./article.js